import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { ContactUsTrackingParams, getContactUsUrl } from 'core/utilities';

export function useContactUsNav()
{
    const history = useHistory();

    return useCallback((params?: ContactUsTrackingParams) =>
    {
        history.push(getContactUsUrl(params));
    }, [ history ]);
}
